export default __webpack_public_path__ + "assets/8e211549b780118a1e7b60eee8606702.jpg";